import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = process.env.REACT_APP_SITE_URL || "https://ravemora.com";
const DEFAULT_OG = `${SITE_URL}/ravemora-lockup.png`;
const DEFAULT_DESCRIPTION =
  "Ravemora Global — Bengaluru-based recruitment company delivering career coaching, executive placement and managed payroll for enterprises.";

export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_OG,
  jsonLd = null,
  noindex = false,
  canonicalUrl = null,
  exactTitle = null,
}) {
  const fullTitle = exactTitle || (title
    ? `${title} | Ravemora Global`
    : "Ravemora Global — Recruitment, Coaching & Payroll");
  const desc = description || DEFAULT_DESCRIPTION;
  const canonical = canonicalUrl || `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Ravemora Global" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={fullTitle} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}

export const organizationJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Ravemora Global",
  legalName: "Ravemora Global",
  url: SITE_URL,
  logo: `${SITE_URL}/ravemora-logo.png`,
  foundingDate: "2023",
  description:
    "Ravemora Global is a Bengaluru-based recruitment company coaching young professionals into industry, placing executive talent, and running payroll for enterprises.",
  email: "info@ravemora.com",
  telephone: "+91-74835-00550",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Guru Krupa Arcade, Basavanapura Main Road, KR Puram",
    addressLocality: "Bengaluru",
    addressRegion: "Karnataka",
    addressCountry: "IN",
  },
  sameAs: [],
});

export const jobPostingJsonLd = (job) => ({
  "@context": "https://schema.org",
  "@type": "JobPosting",
  title: job.title,
  description: job.description,
  identifier: {
    "@type": "PropertyValue",
    name: "Ravemora Global",
    value: job.job_id,
  },
  datePosted: job.posted_at,
  employmentType: (job.employment_type || "FULL_TIME").toUpperCase().replace("-", "_"),
  hiringOrganization: {
    "@type": "Organization",
    name: "Ravemora Global",
    sameAs: SITE_URL,
    logo: `${SITE_URL}/ravemora-logo.png`,
  },
  jobLocation: {
    "@type": "Place",
    address: {
      "@type": "PostalAddress",
      addressLocality: job.location,
      addressCountry: "IN",
    },
  },
  industry: job.industry,
  skills: (job.skills || []).join(", "),
});
